var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dashboard-bg"},[_c('Header'),_c('v-container',{staticClass:"mb-10"},[_c('DialogPendingReport',{attrs:{"open":_vm.historyTransaction.openPendingDialog},on:{"update:open":function($event){return _vm.historyTransaction.closePendingDialog()}}}),_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }